module.exports = __webpack_public_path__ + "static/media/qeatsperf.53520bea.gif";